import React from 'react';

function TrustBadges() {
  return (
    <div className="trust-badges">
      <div className="trust-item">• NO ADDED COLOR</div>
      <div className="trust-item">• NO PRESERVATIVES</div>
      <div className="trust-item">• GLUTEN FREE</div>
      <div className="trust-item">• NO GMO</div>
      <div className="trust-center">• Trusted Quality •</div>
    </div>
  );
}

export default TrustBadges;
